<script>
import App from '@/pages/layouts/app.vue'
import {Link, router} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import Form from '@/pages/users/_form.vue'
import Roles from "@/pages/users/roles";
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
  mixins: [Roles, StoreForm],
  components: {App, Link, Card, Form},
  data() {
    return {
      formRoute: route('api.v1.users.store'),
      redirectRoute: route('users.index'),
      stayOnPageRedirect: route('users.edit', {user: '_id_'})
    }
  }
}
</script>

<template>
  <App title="Gebruiker toevoegen">
    <form id="userForm" @submit.prevent="submit">
      <Form :roles="roles" ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          @backToOverview="stayOnPage = 0"
          :loading="loading || loadingRoles"
          :cancel-route="redirectRoute"
          form-id="userForm"
      />
    </template>
  </App>
</template>